module.exports = __webpack_public_path__ + "ed7b7564f851d29f3dede49a75c68465.jpg";